import { fetcher } from 'fetch-toolkit/lib/server/fetcher/fetcher'
import type { FetcherProps, FetcherResponse } from 'fetch-toolkit/types'

export const noThrowFetcher = <T>({
	url,
	searchParams,
	requestConfig,
	errorConfig,
}: FetcherProps): Promise<FetcherResponse<T | string> | undefined> => {
	return fetcher<T>({
		url,
		searchParams,
		requestConfig,
		errorConfig,
		isThrowError: false,
	})
}
